import {
  Button,
  Card,
  InputWrapper,
  Modal,
  ModalCloseButton,
  SectionSubtitle,
} from '@presentation/components';
import { useTranslation } from '@presentation/utils';
import type { FC } from 'react';
import type { AuthModalProps } from './types';

export * from './types';

export const AuthModal: FC<AuthModalProps> = (props) => {
  const { translate } = useTranslation();

  const {
    modal,
    subtitle = translate('common.modals.noUser.subtitle'),
    onJoinClick,
    onLoginClick,
  } = props;

  return (
    <Modal {...modal}>
      <Card size="small" isModal>
        <ModalCloseButton modal={modal} />
        <SectionSubtitle>
          <span dangerouslySetInnerHTML={{ __html: subtitle }} />
        </SectionSubtitle>
        <InputWrapper>
          <Button color="blue" onClick={onLoginClick}>
            {translate('common.buttons.loggingin')}
          </Button>
        </InputWrapper>
        <InputWrapper>
          <Button color="blue" outlined onClick={onJoinClick}>
            {translate('common.buttons.register')}
          </Button>
        </InputWrapper>
      </Card>
    </Modal>
  );
};
